import { Button, Layout, PageHeader, Space, Table } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { apiClient, apiErrorMessage, getApiBaseUrl } from '../../utils';
import { FileExcelOutlined, ReloadOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

export function FieldRulesReport() {
  const { Content } = Layout;
  const history = useHistory();

  const [fieldRulesAndPermissionsList, setFieldRulesAndPermissionsList] = useState<any[]>();
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(() => {
    setLoading(true);
    apiClient
      .get('reports/field-rules')
      .then(response => {
        setFieldRulesAndPermissionsList(response.data);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const onBackClick = () => {
    history.goBack();
  };

  const onRefreshClick = () => {
    loadData();
  };

  const onExcelExportClick = () => {
    const baseApiUrl = getApiBaseUrl() + '/api/';
    const url = `${baseApiUrl}reports/field-rules/export`;
    window.open(url, '_blank');
  };

  const tableColumns = [
    {
      title: 'Veri seti',
      dataIndex: 'gridName',
      key: 'gridName',
    },
    {
      title: 'Veri elemanı',
      dataIndex: 'fieldName',
      key: 'fieldName',
    },
    {
      title: 'Veri tipi',
      dataIndex: 'dataType',
      key: 'dataType',
    },
    {
      title: 'Kurallar',
      dataIndex: 'rules',
      key: 'rules',
      render: (rules: string[]) => {
        if (!rules?.length) {
          return null;
        }
        return (
          <Space direction="vertical">
            {rules?.map(rule => (
              <span>{rule}</span>
            ))}
          </Space>
        );
      },
    },
    {
      title: 'Yetkiler',
      dataIndex: 'permissions',
      key: 'permissions',
      render: (permissions: string[]) => {
        if (!permissions?.length) {
          return null;
        }
        return (
          <>
            {permissions?.map(permission => {
              const permissionArray = permission.split(' - Kurallar: ');
              const permissionDefinition = permissionArray[0];
              let rules: string[] = [];
              if (permissionArray.length > 1) {
                rules = permissionArray[1].split(' --- ').map(v => v.trim());
              }
              return (
                <>
                  <span>{permissionDefinition}</span>
                  <br />
                  {rules?.map(rule => {
                    const conditionArray = rule.split(' -- ').map(v => v.trim());
                    const rulesTitle = conditionArray[0];
                    const conditions = conditionArray.slice(1).map(v => '- ' + v);

                    return (
                      <>
                        <span>{rulesTitle}</span>
                        <br />
                        {conditions.map(condition => (
                          <>
                            <span>{condition}</span>
                            <br />
                          </>
                        ))}
                      </>
                    );
                  })}
                  <br />
                </>
              );
            })}
          </>
        );
      },
    },
  ];

  return (
    <>
      <PageHeader
        title="PLM Kalem - Mastar eşleştirmeleri"
        onBack={onBackClick}
        extra={[
          <Button type="primary" icon={<FileExcelOutlined />} onClick={onExcelExportClick}>
            Excel'e aktar
          </Button>,
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={fieldRulesAndPermissionsList} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
